<div class="main-content">
  <div class="container-fluid">

    <div *ngIf="loading" class="text-center" style="margin-top: 40px">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>

    <div *ngIf="!loading">
      <h3>My SOT Submissions</h3>

      <p *ngIf="submissions.length === 0">You have not submitted the Standards Orientation Tool yet.</p>

      <table *ngIf="submissions.length > 0" class="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Organisation</th>
            <th>TRL</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let submission of submissions">
            <td>{{ getDate(submission) | date:'dd/MM/yyyy' }}</td>
            <td>{{ submission.organisation }}</td>
            <td>{{ getTrlLabel(submission) }}</td>
            <td>
              <button class="btn btn-info btn-sm" (click)="onView(submission)">View</button>
              <button class="btn btn-info btn-sm" (click)="onExport(submission)">Export PDF</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
